import request from '@/utils/http';
// 表格数据
export const getList = (params) => {
    return request({
        url: `/api-srm-web/order/ltms/loadTasksData`,
        method: 'get',
        params
    });
};

// 双击表格页面接口
export const getEtTaskMaterielItem = (data) => {
    return request({
        url: `/api-srm-web/order/ltms/getEtTaskMaterielItem`,
        method: 'post',
        data
    });
};

// 勾选排车获取的承运商
export const getEtTaskItemByAssighNos = (data) => {
    return request({
        url: `/api-srm-web/order/ltms/getEtTaskItemByAssighNos`,
        method: 'post',
        data
    });
};

// 保存排车
export const saveEtDispatchOrder = (data) => {
    return request({
        url: `/api-srm-web/order/ltms/saveEtDispatchOrder`,
        method: 'post',
        data
    });
};

// 装车排序保存
export const lspLoadingSeq = (data) => {
    return request({
        url: `api-srm-web/order/ltms/lspLoadingSeq`,
        method: 'post',
        data
    });
};

// 片区下拉框数据
export const loadDistrictKeyData = (params) => {
    return request({
        url: `/api-srm-web/order/ltms/loadDistrictKeyData`,
        method: 'get',
        params
    });
};

// 发运类型默认值
export const shippingTypeData = (data) => {
    return request({
        url: `api-srm-web/order/ltms/checkJudgeLingDanItem`,
        method: 'post',
        data
    });
};
export const getCarTypeApi = (data) => {
    return request({
        url: `/api-srm-web/order/ltms/checkCarTypeItem`,
        method: 'post',
        data
    });
};
export const checkCarNameNetItemApi = (data) => {
    return request({
        url: `/api-srm-web/order/ltms/checkCarNameNetItem`,
        method: 'post',
        data
    });
};
